import { render } from "./gaussian-blur.vue?vue&type=template&id=63d07a24&scoped=true"
import script from "./gaussian-blur.vue?vue&type=script&lang=js"
export * from "./gaussian-blur.vue?vue&type=script&lang=js"

import "./gaussian-blur.vue?vue&type=style&index=0&id=63d07a24&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d07a24"]])

export default __exports__